<template>
  <div class="InfoContent grid grid-cols-2 gap-y-8 gap-x-4 max-w-6xl mx-auto">
    <landscape-map
      class="LandscapeMap"
      :class="{LandscapeMapNoWordcloud: !allowedToWordcloud}"
    />
    <word-cloud-summary v-if="allowedToWordcloud" class="WordCloudSummary" />
    <landscape-description
      v-if="!selectedActor"
      :landscape="currentLandscape"
      class="LandscapeDescription mt-8 d"
    />
    <template v-else>
      <div class="ManagersActors">
        <managers class="min-w-52 mb-12 mr-8" :list="managers" />
        <metrics :stats="selectedActor.stats" />
      </div>
      <actor-profile class="ActorProfile" :profile="selectedActor.profile" />
    </template>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import ActorProfile from '@/components/landscape/info/ActorProfile'
import LandscapeDescription from '@/components/landscape/info/LandscapeDescription'
import Managers from '@/components/landscape/info/Managers'
import Metrics from '@/components/landscape/info/Metrics'
import WordCloudSummary from '@/components/landscape/info/wordcloud/WordCloudSummary'
import LandscapeMap from '@/components/landscape/LandscapeMap'
export default {
  name: 'InfoContent',
  components: {
    LandscapeDescription,
    ActorProfile,
    Metrics,
    Managers,
    WordCloudSummary,
    LandscapeMap
  },
  props: {
    managers: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters(['selectedActor', 'currentLandscape', 'allowedToWordcloud'])
  }
}
</script>

<style scoped>
.LandscapeMap,
.WordCloudSummary,
.LandscapeDescription,
.ManagersActors,
.ActorProfile {
  order: 2;
  grid-column: 1 / span 2;
}

.LandscapeMap {
  order: 0;
}
.LandscapeDescription {
  order: 1;
}
@media (min-width: 480px) {
  .ManagersActors {
    display: flex;
  }
}
@media (--desktop) {
  .LandscapeMap,
  .WordCloudSummary {
    order: 0;
    grid-column: span 1;
  }
  .LandscapeMapNoWordcloud {
    order: 0;
    grid-column: span 2;
  }
  .ManagersActors {
    display: block;
    grid-column: 1 / span 1;
  }
  .ActorProfile {
    grid-column: 2 / span 1;
  }
}
@media (min-width: 1280px) {
  .ManagersActors {
    display: flex;
  }
}
</style>
